export default {
  menuAdmin: '菜单管理',
  menuList: '菜单列表',
  addMeun: '添加菜单',

  table: {
    menuName: '菜单名称',
    menuNameVn: '菜单名称越南文',

    menuNameEn: '菜单名称英文',

    menuCode: '菜单编码',
    menuGrade: '菜单等级',
    menuParent: '父菜单编码',
    menuParentName: '父菜单名称',
    menuStatus: '菜单状态',
    menuUrl: '菜单URL',
    apiUrl: '菜单apiUrl',
    compileMenu: '编辑菜单',
    addMenu: '添加菜单',
    sort: '排序'
  },

  data: {
    LevelOnemenu: '一级菜单',
    LevelTwomenu: '二级菜单',
    LevelThreebutton: '三级按钮',
    checkmenuGrade: '请选择菜单等级',
    checkmenuCode: '请输入菜单编码',
    checkmenuName: '请输入菜单名称',
    checkmenuNameVn: '请输入菜单名称越南文',

    checkmenuNameEn: '请输入菜单名称英文',

    menuUrl: '请输入菜单URL',
    apiUrl: '请输入菜单apiUrl',
    addMenuSucceed: '添加菜单成功',
    addMenuError: '添加菜单失败',
    changMenuSucceed: '修改菜单成功',
    changMenuError: '修改菜单失败',
    sort: '请输入菜单排序'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/menumanage.js